'use client';

import { percentageVisualization } from '@/components/Table/helper';
import { NotAvailable } from './NotAvailable';
type DataValue = string | undefined | null;
const LABELS: Record<string, DataValue> = {
  id: 'Id',
  table_adapter: 'Adapter',
  database_name: 'Database name',
  table_name: 'Table name',
  minimum: 'Minimum',
  maximum: 'Maximum',
  mean: 'Mean',
  median: 'Median',
  distinct: 'Unique Values',
  unique: 'Unique Percent',
  missing: 'Missing Percent',
  stdev: 'Standard Deviation'
} as const;
export const classes = {
  wrapper: 'p-5 bg-white',
  group: 'text-xs font-mono flex flex-col gap-5',
  item: 'flex gap-10',
  label: 'w-5/12 whitespace-nowrap',
  value: 'w-7/12 break-all w-full flex line-clamp-6 gap-2 items-center justify-end'
};
interface DataListProps {
  id: string;
  data: Record<string, DataValue>;
  showMissing?: boolean;
  showFallback?: boolean;
}
const isHidden = ([key]: [string, DataValue]) => !['histogram', 'length_histogram'].includes(key);
const isPercentage = (key: string) => ['unique', 'missing'].includes(key);
const isInverted = (key: string) => key === 'missing';
export function DataList({
  id,
  data,
  showMissing = false,
  showFallback = false
}: DataListProps) {
  return <div className={classes.group}>
      {Object.entries(data).filter(isHidden).map(([key, value]: [key: string, value: DataValue]) => {
      const isVisible = showMissing ? true : !!value;
      const valueEl = value ? isPercentage(key) ? percentageVisualization(Number(value), isInverted(key)) : value : showFallback && <NotAvailable />;
      return isVisible && <div key={`${id}-${key}`} className={classes.item}>
                <span className={classes.label}>{LABELS?.[key]}</span>
                <span className={classes.value}>{valueEl}</span>
              </div>;
    })}
    </div>;
}